import GroupingSelectorWithDetailsLevel from './GroupingSelectorWithDetailsLevel'
import messageResource from '../messageResource'
import {ReportGroupingLevel} from './constants'
import _ from 'underscore'

export default function BudgetGroupingSelector() {
    this.constructor = BudgetGroupingSelector;
}

BudgetGroupingSelector.prototype = _.create(GroupingSelectorWithDetailsLevel.prototype);

BudgetGroupingSelector.prototype.init = function(selectorId, selectedValues, isBTYEnabled, changesCallback)
{
    this.isBTYEnabled = isBTYEnabled;

    GroupingSelectorWithDetailsLevel.prototype.init.call(this, selectorId, 3, selectedValues, changesCallback);

    return this;
};

BudgetGroupingSelector.prototype.fillListSelector = function(listSelector, level)
{
    if( level <= 2 )
    {
        if (level > 0)
        {
            const textKey = level === 1 ? "report.form.dont_use_2nd_grouping_level" : "report.form.dont_use_3rd_grouping_level";
            listSelector.addItems([{
                                       text: messageResource.getMessage( textKey ),
                                       value: ReportGroupingLevel.NONE
                                   }]);
            listSelector.addSeparator();
        }
        listSelector.addItems( [{
                                    text: messageResource.getEscapedMessage( "common.Customers" ),
                                    value: ReportGroupingLevel.CUSTOMER
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Projects" ),
                                    value: ReportGroupingLevel.PROJECT
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.form.projects_joined_by_name" ),
                                    value: ReportGroupingLevel.PROJECT_NAME
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Tasks" ),
                                    value: ReportGroupingLevel.TASK
                                },
                               {
                                    text: messageResource.getEscapedMessage( "report.form.tasks_joined_by_name" ),
                                    value: ReportGroupingLevel.TASK_NAME
                                }]
        );
        if( this.isBTYEnabled )
        {
            listSelector.addItems( [{
                                        text: messageResource.getMessage( "report.common.billing_types" ),
                                        value: ReportGroupingLevel.BILLING_TYPE
                                    }] );
        }
    } else {
        listSelector.addItems( [{
                                    text: messageResource.getMessage( "report.hide_details" ),
                                    value: ReportGroupingLevel.NONE
                                },
                               {
                                    text: messageResource.getEscapedMessage( "common.Tasks" ),
                                    value: ReportGroupingLevel.TASK
                                },
                               {
                                    text: messageResource.getMessage( "report.users" ),
                                    value: ReportGroupingLevel.USER
                                }]
        );
    }
};

BudgetGroupingSelector.prototype.thereAreNo = function(level)
{
    const first = this.getListSelectorValue(0);
    const second = this.getListSelectorValue(1);
    const third = this.getListSelectorValue(2);

    return first !== level && second !== level && third !== level;
};

BudgetGroupingSelector.prototype.thereAre = function(level)
{
    const first = this.getListSelectorValue(0);
    const second = this.getListSelectorValue(1);
    const third = this.getListSelectorValue(2);

    return first === level || second === level || third === level;
};

BudgetGroupingSelector.prototype.updateDetailsOptions = function()
{
    const currentDetailsValue = this.getDetailsListSelectorValue();

    if (this.thereAreNo(ReportGroupingLevel.TASK))
    {
        this.detailsListSelector.getItemByValue(ReportGroupingLevel.TASK).show();
    }
    else
    {
        this.detailsListSelector.getItemByValue(ReportGroupingLevel.TASK).hide();
        if (currentDetailsValue === ReportGroupingLevel.TASK)
            this.detailsListSelector.setActiveItemByValue(ReportGroupingLevel.USER);
    }
};

BudgetGroupingSelector.prototype.treeStyleMap =
{
    '+++': ['tree-row-A', 'tree-row-SA', 'tree-row-SSA'],
    '++-': ['tree-row-A', 'tree-row-SA', 'tree-row-SSI'],
    '+-+': ['tree-row-A', 'tree-row-SJ', 'tree-row-SAL'],
    '+--': ['tree-row-A', 'tree-row-SI', 'tree-row-SSI'],
    '-++': ['tree-row-J', 'tree-row-AL', 'tree-row-SSA'],
    '-+-': ['tree-row-J', 'tree-row-AL', 'tree-row-SSI'],
    '--+': ['tree-row-J', 'tree-row-JL', 'tree-row-ALL'],
    '---': ['tree-row-I', 'tree-row-SI', 'tree-row-SSI']
};

BudgetGroupingSelector.prototype.updateTree = function()
{
    const secondShown = this.getListSelectorValue(1) !== ReportGroupingLevel.NONE;
    const thirdShown = this.getListSelectorValue(2) !== ReportGroupingLevel.NONE;
    const detailsShown = this.getDetailsListSelectorValue() !== ReportGroupingLevel.NONE;

    const key = (secondShown ? '+' : '-') + (thirdShown ? '+' : '-') + (detailsShown ? '+' : '-');
    const styles = this.treeStyleMap[key];

    this.setRowClassName(1, styles[0]);
    this.setRowClassName(2, styles[1]);
    this.setRowClassName(3, styles[2]);
};



// WEBPACK FOOTER //
// ./web/js/reports/BudgetGroupingSelector.js